
import MoreEventCard from "./MoreEventCard.vue";
import { mapState } from "vuex";
import { formatDateNoHours } from "~/utils/common";
export default {
  head: {
    script: [
      {
        async: true,
        defer: true,
        crossorigin: "anonymous",
        src: "https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v16.0",
        nonce: "cJMAH2j3",
      },
    ],
  },
  components: { MoreEventCard },
  props: {
    location: {
      type: String,
      default: "",
    },
    school_name: {
      type: String,
      default: "",
    },
    registion_start_time: {
      type: String,
      default: "",
    },

    num_of_register: {
      type: Number,
      default: 0,
    },
    other_event: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      host: "",
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
    };
  },
  computed: {
    ...mapState("Event", ["eventLoading"]),

    startTimeFormat() {
      return formatDateNoHours(this.registion_start_time);
    },
  },
  mounted() {
    const fullUrl = this.$nuxt.context.req
      ? `${this.$nuxt.context.req.protocol}://${this.$nuxt.context.req.get(
        "host"
      )}${this.$nuxt.context.req.url}`
      : window.location.href;
    this.host = fullUrl;
  },
  methods: {
    share() {
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.host
      )}`;
      window.open(
        shareUrl,
        "_blank",
        "toolbar=0,status=0,width=626,height=436"
      );
    },
  },
};
